<template>
  <div>
    <PageHeader :title="title" :items="items" />
    
    <div class="row">
      <div class="col-12">
        <div class="card-box">
          <TableAnticipation
            v-if="!isHeaven"
            :currency="'BRL'"
            @update-antecipations="updateAnticipations"
            @open-modal-details="openModal"
          />
          <TableAnticipation
            v-else
            :currency="'USD'"
            @update-antecipations="updateAnticipations"
            @open-modal-details="openModal"
          />
        </div>
      </div>
    </div>

    <Modal :antecipation="idAntecipation" />
  </div>
</template>

<script>
import appConfig from '@src/app.config'
import PageHeader from '@components/page-header'
import Modal from './modal-details.vue'
import TableAnticipation from './tableAnticipation'

export default {
  name: "AntecipacaoList",
  page: {
    title: 'Antecipação',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Modal, PageHeader, TableAnticipation},
  data() {
    return {
      anticipationsRequestedBRL: false,
      anticipationsRequestedUSD: false,
      anticipationsRequestedEUR: false,
      anticipationsRequestedGBP: false,
      client_id: -1,
      currentPage: 1,
      fields: [
        { key: 'id', label: 'ID', sortable: true },
        { key: '_user', label: 'Cliente', sortable: false },
        { key: '_score', label: 'Score', sortable: false },
        { key: 'created_at', label: 'Data', sortable: false },
        { key: 'fee', label: 'Taxa', sortable: false },
        { key: 'amount', label: 'Valor', sortable: false },
        { key: 'status', label: 'Status', sortable: false },
        { key: '_actions', label: 'Ações', sortable: false },
      ],
      idAntecipation: {
        id: null,
        amount: 0
      },
      items: [
        {
          text: 'Início',
          href: '/',
        },
        {
          text: 'Antecipação',
          active: true,
        },
      ],
      tabIndex: 0,
      title: 'Antecipação',
    }
  },
  computed: {
    isHeaven() {
      return this.$store.getters["getIsHeaven"]
    }
  },
  methods: {
    updateAnticipations(anticipationsRequested, currency) {
      if(currency === "BRL") this.anticipationsRequestedBRL = anticipationsRequested; 
      if(currency === "USD") this.anticipationsRequestedUSD = anticipationsRequested; 
      if(currency === "EUR") this.anticipationsRequestedEUR = anticipationsRequested; 
      if(currency === "GBP") this.anticipationsRequestedGBP = anticipationsRequested; 
    },
    openModal(data) {
      this.idAntecipation = data;
      setTimeout(() => {
        this.$bvModal.show('details_antecipation');
      }, 200);
    },
  },
}
</script>

<style scoped>
.badge-custom {
  color: transparent;
  font-size: 5px;
}
</style>
